// extracted by css-extract-rspack-plugin
export default {"root":"Ed9L9","grid":"T6qeq","card":"lmjvE","transparent":"UfErQ","textContent":"dOgb9","textContentHeading":"atSvw"};